export default "__VITE_ASSET__Ccfsklsy__"